module.exports = __webpack_public_path__ + "static/img/image17.e5c85f39.png";